var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 200,
    viewBox: "0 0 311 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_3267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_759_3267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 311,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 200,
    rx: 18,
    fill: "#0B1F51"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_759_3267)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310.721,
    height: 114,
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.952 27.3258C283.269 37.1724 282.93 52.9932 275.26 70.8452C267.61 88.6518 252.749 108.249 232.467 125.38C212.184 142.511 190.377 153.885 171.542 158.449C152.659 163.024 137.004 160.713 128.687 150.866C120.37 141.019 120.71 125.199 128.379 107.347C136.029 89.54 150.891 69.9426 171.173 52.8117C191.455 35.6807 213.262 24.3067 232.097 19.7428C250.981 15.1673 266.635 17.4791 274.952 27.3258Z",
    stroke: "url(#paint0_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.411 31.4176C286.728 41.2642 286.389 57.085 278.719 74.937C271.069 92.7436 256.208 112.341 235.926 129.472C215.643 146.603 193.836 157.977 175.001 162.541C156.118 167.116 140.463 164.804 132.146 154.958C123.829 145.111 124.169 129.29 131.838 111.438C139.488 93.6317 154.35 74.0344 174.632 56.9035C194.914 39.7725 216.721 28.3985 235.556 23.8346C254.44 19.2591 270.094 21.5709 278.411 31.4176Z",
    stroke: "url(#paint1_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87 35.5133C290.187 45.3599 289.848 61.1807 282.178 79.0327C274.528 96.8393 259.667 116.437 239.385 133.568C219.102 150.699 197.295 162.073 178.46 166.636C159.577 171.212 143.922 168.9 135.605 159.053C127.288 149.207 127.628 133.386 135.297 115.534C142.947 97.7275 157.809 78.1301 178.091 60.9992C198.373 43.8682 220.18 32.4942 239.015 27.9303C257.899 23.3548 273.553 25.6666 281.87 35.5133Z",
    stroke: "url(#paint2_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.327 39.609C293.644 49.4556 293.305 65.2764 285.635 83.1284C277.985 100.935 263.124 120.532 242.842 137.663C222.559 154.794 200.752 166.168 181.917 170.732C163.034 175.308 147.379 172.996 139.062 163.149C130.745 153.303 131.085 137.482 138.754 119.63C146.404 101.823 161.266 82.2258 181.548 65.0949C201.83 47.9639 223.637 36.5899 242.472 32.026C261.356 27.4505 277.01 29.7623 285.327 39.609Z",
    stroke: "url(#paint3_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.786 43.7027C297.103 53.5493 296.764 69.3701 289.094 87.2221C281.444 105.029 266.583 124.626 246.301 141.757C226.018 158.888 204.211 170.262 185.376 174.826C166.493 179.401 150.838 177.09 142.521 167.243C134.204 157.396 134.544 141.576 142.213 123.724C149.863 105.917 164.725 86.3196 185.007 69.1886C205.289 52.0576 227.096 40.6837 245.931 36.1198C264.815 31.5443 280.469 33.8561 288.786 43.7027Z",
    stroke: "url(#paint4_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.243 47.7965C300.56 57.6431 300.221 73.4639 292.551 91.3159C284.901 109.122 270.04 128.72 249.758 145.851C229.475 162.982 207.668 174.356 188.833 178.92C169.95 183.495 154.295 181.183 145.978 171.337C137.661 161.49 138.001 145.669 145.67 127.817C153.32 110.011 168.182 90.4133 188.464 73.2824C208.746 56.1514 230.553 44.7774 249.388 40.2135C268.272 35.638 283.926 37.9498 292.243 47.7965Z",
    stroke: "url(#paint5_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.702 51.8902C304.019 61.7368 303.68 77.5576 296.01 95.4096C288.36 113.216 273.499 132.814 253.217 149.945C232.934 167.076 211.127 178.449 192.292 183.013C173.409 187.589 157.754 185.277 149.437 175.43C141.12 165.584 141.46 149.763 149.129 131.911C156.779 114.104 171.641 94.5071 191.923 77.3761C212.205 60.2451 234.012 48.8712 252.847 44.3073C271.731 39.7318 287.385 42.0436 295.702 51.8902Z",
    stroke: "url(#paint6_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.159 55.9859C307.476 65.8326 307.137 81.6533 299.467 99.5053C291.817 117.312 276.956 136.909 256.674 154.04C236.391 171.171 214.584 182.545 195.749 187.109C176.866 191.685 161.211 189.373 152.894 179.526C144.578 169.68 144.917 153.859 152.586 136.007C160.236 118.2 175.098 98.6028 195.38 81.4718C215.662 64.3408 237.469 52.9669 256.304 48.403C275.188 43.8275 290.842 46.1393 299.159 55.9859Z",
    stroke: "url(#paint7_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.618 60.0797C310.935 69.9263 310.596 85.7471 302.926 103.599C295.276 121.406 280.415 141.003 260.133 158.134C239.85 175.265 218.043 186.639 199.208 191.203C180.325 195.778 164.67 193.467 156.353 183.62C148.036 173.773 148.376 157.952 156.045 140.1C163.695 122.294 178.557 102.697 198.839 85.5656C219.121 68.4346 240.928 57.0606 259.763 52.4967C278.647 47.9212 294.301 50.233 302.618 60.0797Z",
    stroke: "url(#paint8_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.075 64.1734C314.392 74.0201 314.053 89.8408 306.383 107.693C298.733 125.499 283.872 145.097 263.59 162.228C243.307 179.359 221.5 190.733 202.665 195.297C183.782 199.872 168.127 197.56 159.81 187.714C151.494 177.867 151.833 162.046 159.502 144.194C167.152 126.388 182.014 106.79 202.296 89.6593C222.578 72.5283 244.385 61.1544 263.22 56.5905C282.104 52.015 297.758 54.3268 306.075 64.1734Z",
    stroke: "url(#paint9_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.534 68.2672C317.851 78.1138 317.512 93.9346 309.842 111.787C302.192 129.593 287.331 149.191 267.049 166.321C246.766 183.452 224.959 194.826 206.124 199.39C187.241 203.966 171.586 201.654 163.269 191.807C154.953 181.961 155.292 166.14 162.961 148.288C170.611 130.481 185.473 110.884 205.755 93.7531C226.037 76.6221 247.844 65.2481 266.679 60.6842C285.563 56.1087 301.217 58.4205 309.534 68.2672Z",
    stroke: "url(#paint10_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.991 72.3609C321.308 82.2076 320.969 98.0283 313.299 115.88C305.649 133.687 290.788 153.284 270.506 170.415C250.224 187.546 228.416 198.92 209.581 203.484C190.698 208.06 175.043 205.748 166.726 195.901C158.41 186.055 158.749 170.234 166.418 152.382C174.068 134.575 188.93 114.978 209.212 97.8468C229.494 80.7158 251.301 69.3419 270.136 64.778C289.02 60.2025 304.674 62.5143 312.991 72.3609Z",
    stroke: "url(#paint11_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.45 76.4547C324.767 86.3013 324.428 102.122 316.758 119.974C309.108 137.781 294.247 157.378 273.965 174.509C253.682 191.64 231.875 203.014 213.04 207.578C194.157 212.153 178.502 209.842 170.185 199.995C161.869 190.148 162.208 174.327 169.877 156.475C177.527 138.669 192.389 119.072 212.671 101.941C232.953 84.8096 254.76 73.4356 273.595 68.8717C292.479 64.2962 308.133 66.608 316.45 76.4547Z",
    stroke: "url(#paint12_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.909 80.5504C328.226 90.397 327.887 106.218 320.217 124.07C312.567 141.876 297.706 161.474 277.424 178.605C257.141 195.736 235.334 207.11 216.499 211.674C197.616 216.249 181.961 213.937 173.644 204.091C165.328 194.244 165.667 178.423 173.336 160.571C180.986 142.765 195.848 123.167 216.13 106.036C236.412 88.9053 258.219 77.5313 277.054 72.9674C295.938 68.3919 311.592 70.7037 319.909 80.5504Z",
    stroke: "url(#paint13_linear_759_3267)",
    strokeWidth: 1.47658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.368 84.6461C331.685 94.4927 331.346 110.313 323.676 128.165C316.026 145.972 301.165 165.569 280.883 182.7C260.6 199.831 238.793 211.205 219.958 215.769C201.075 220.345 185.42 218.033 177.103 208.186C168.786 198.34 169.126 182.519 176.795 164.667C184.445 146.86 199.307 127.263 219.589 110.132C239.871 93.001 261.678 81.627 280.513 77.0632C299.397 72.4876 315.051 74.7994 323.368 84.6461Z",
    stroke: "url(#paint14_linear_759_3267)",
    strokeWidth: 1.47658
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 114H311V182C311 191.941 302.941 200 293 200H18C8.05888 200 0 191.941 0 182V114Z",
    fill: "#3F3F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_759_3267",
    x1: 237.085,
    y1: 4.17969,
    x2: 146.585,
    y2: 82.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_759_3267",
    x1: 240.544,
    y1: 8.27149,
    x2: 150.044,
    y2: 86.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_759_3267",
    x1: 244.003,
    y1: 12.3672,
    x2: 153.503,
    y2: 90.8672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_759_3267",
    x1: 247.46,
    y1: 16.4629,
    x2: 156.96,
    y2: 94.9629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_759_3267",
    x1: 250.919,
    y1: 20.5566,
    x2: 160.419,
    y2: 99.0566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_759_3267",
    x1: 254.376,
    y1: 24.6504,
    x2: 163.876,
    y2: 103.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_759_3267",
    x1: 257.835,
    y1: 28.7441,
    x2: 167.335,
    y2: 107.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_759_3267",
    x1: 261.292,
    y1: 32.8399,
    x2: 170.792,
    y2: 111.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_759_3267",
    x1: 264.751,
    y1: 36.9336,
    x2: 174.251,
    y2: 115.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_759_3267",
    x1: 268.208,
    y1: 41.0274,
    x2: 177.708,
    y2: 119.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_759_3267",
    x1: 271.667,
    y1: 45.1211,
    x2: 181.167,
    y2: 123.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_759_3267",
    x1: 275.124,
    y1: 49.2149,
    x2: 184.624,
    y2: 127.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_759_3267",
    x1: 278.583,
    y1: 53.3086,
    x2: 188.083,
    y2: 131.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_759_3267",
    x1: 282.042,
    y1: 57.4043,
    x2: 191.542,
    y2: 135.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_759_3267",
    x1: 285.501,
    y1: 61.5,
    x2: 195.001,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_3267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 200,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBackground);
export default __webpack_public_path__ + "static/media/payment-background.1f8b180ae424455a40a31ebaf77d7071.svg";
export { ForwardRef as ReactComponent };